import React from 'react'
import styled from 'styled-components'

export default function Tile(props: {
  icon: React.ReactNode
  title: string
  children: React.ReactNode
}) {
  return (
    <TileBox>
      <IconCircle>{props.icon}</IconCircle>
      <TileContent>
        <TileTitle>{props.title}</TileTitle>
        <TileText>{props.children}</TileText>
      </TileContent>
    </TileBox>
  )
}

const TileBox = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${(props) => props.theme.spacing[4]};
  padding: ${(props) => props.theme.spacing[5]};
  border: 1px solid ${(props) => props.theme.colors.gray300};
  border-radius: 8px;
  background: ${(props) => props.theme.colors.white};
`

const IconCircle = styled.div`
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => `${props.theme.colors.primary}1a`};
  color: ${(props) => props.theme.colors.primary};

  i {
    font-size: 16px;
  }
`

const TileContent = styled.div``

const TileTitle = styled.h4`
  margin: 0 0 ${(props) => props.theme.spacing[1]} 0;
  font-size: 15px;
  font-weight: 600;
  color: ${(props) => props.theme.colors.text.primary};
`

const TileText = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 20px;
  color: ${(props) => props.theme.colors.text.muted};
`
